<template>
    <div>
        <app-title text="Tareas asignadas para observar" />
        <app-task-filters
            @filter="onFilter"
            @clean="resetFilters"
        />
        <app-tasks-to-observe-list
            :data="tasks"
            @changePage="onChangePage"
            @sort="onSort"
            @create-note="startCreateNote"
        />
        <!-- INICIO popUp's -->
        <app-pop-up title="Agregar nota a la tarea" id="add-comment-task" :onClose="cleanNoteForm">
            <div slot="body">
                <app-add-note-task v-if="selectedTask"
                    id="add-comment-task"
                    :task="selectedTask" 
                    :on-save="onSaveNote"
                />
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="saveNote"> Guardar</button>
            </div> 
        </app-pop-up>
        <!-- FIN popUp's -->
    </div>
</template>
<script>
import TasksToObserveList from './TasksToObserveList/TasksToObserveList.vue';
import tasksRepository from '../../../../repositories/tasks.repository.js';
import TaskFilters from './TasksToObserveFilters/TasksToObserveFilters.vue';
import AddNoteTask from '../NotesTask/AddNoteTask/AddNoteTask.vue';
export default {
    components: {
        appTasksToObserveList: TasksToObserveList,
        appTaskFilters: TaskFilters,
        appAddNoteTask: AddNoteTask
    },

    data(){
        return{
            tasks: {},
            page: 1,
            filters: null,
            sort: {
                sortBy: 'due_date',
                sortDir: 'asc'
            },
            selectedTask: '',
        }
    },

    methods: {
        loadTasks(){
            const tr = {...tasksRepository};
            const payload = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir};
            tr.getTasksToObserveByUser(this.user.id, payload, this.page)
            .then(data => {
                
                const tasks = data.data;
                const fTasks = tasks.map(item => {
                    const today = moment();
                    const dueDate = moment(item.due_date);
                    const classes = today.isSame(dueDate, 'day')?'today':(today.isAfter(dueDate) && !item.resolution_date?'overdue': '');
                    const _rowDetails = true;
                    return {...item, classes, _rowDetails};
                });                
                const theData = {...data, data: fTasks};
                this.tasks = theData;
            })
            .catch(error=> toastr.error('Error al cargar las tareas del usuario'));
        },
        onChangePage(page){
            this.page = page;
            this.loadTasks();
        },
        onFilter(filters){
            this.filters = filters;
            this.loadTasks();
        },
        resetFilters(filters){
            this.filters = null;
            this.loadTasks();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadTasks();
        },
        deleteComment(payload) {
            const task = this.tasks.data.find(task => task.id === payload.taskId);

            if(!task) return;

            task.detailsShowing = true;

            task.notes = task.notes.filter(note => note.id !== payload.noteId);
        },
        saveNote(){
            this.$bus.$emit('add-comment-task.save');
        },
        onSaveNote() {
            this.$bus.$emit('add-comment-task.close');
            this.loadTasks();
        },
        cleanNoteForm() {
            this.$bus.$emit('add-comment-task.clean');
        },
        startCreateNote(task){
            this.selectedTask = task;
            this.$bus.$emit('add-comment-task.open');
        },
    },

    created(){
        this.loadTasks();
        this.$bus.$on('task-note.delete', this.deleteComment);
        
    }
    
}
</script>

